export default __webpack_public_path__ + "static/media/image1-02.54f3b036.jpg";